module.exports = __webpack_public_path__ + "img/trainingdoc1.fd2edaab.png";